// Munchtown place <script defer src="{{ 'munchtown.js' | asset_url }}"></script>
console.log(
  '%c munchtown.se ',
  'background: #272727; color: #ffdd55; font-size: 16px; padding: 4px 8px; border-radius: 4px;'
);


// Payment on product page
document.addEventListener("DOMContentLoaded", function() {
    const toggle = document.querySelector('.more-toggle');
    const hiddenIcons = document.querySelector('.hidden-icons');

    if (toggle && hiddenIcons) {
      toggle.addEventListener('click', function() {
        hiddenIcons.classList.toggle('active');
        toggle.style.display = 'none'; 
      });
    }
  });